import React, { lazy, Suspense } from "react";
import Modal from "react-bootstrap/Modal";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Button from "react-bootstrap/Button";
import { Spinner } from "react-bootstrap";
// Components
import ExportsTab from "../../pages/home/full-modal-components/exports-tab/ExportsTab";
import ShipmentTab from "../../pages/home/full-modal-components/shipment-tab/ShipmentTab";
// import WalletTab from "../../pages/home/full-modal-components/wallet-tab/WalletTab";
const WalletTab = lazy(() =>
  import("../../pages/home/full-modal-components/wallet-tab/WalletTab")
);

const TransferTab = lazy(() =>
  import("../../pages/home/full-modal-components/transfer-tab/TransferTab")
);
const FullModal = ({ data, onHide, lang }) => {
  const dataTranslate = require(`../../../translate/${
    lang === "AR" ? "arabic" : "english"
  }/data.json`);

  return (
    <Modal
      fullscreen
      show={data.isShow}
      onHide={onHide}
      dialogClassName="modal-90w"
      aria-labelledby="example-custom-modal-styling-title"
      className="fullscreen-modal"
      dir={lang === "AR" ? "rtl" : "ltr"}
    >
      {/* <Modal.Header
        closeButton
        className="fullscreen-modal-header"
      ></Modal.Header> */}
      <Modal.Body className="fullscreen-modal-body">
        <div className="fullscreen-modal-body-closeBtn">
          <Button
            style={lang === "AR" ? { float: "left" } : { float: "right" }}
            onClick={onHide}
            variant="danger"
          >
            X
          </Button>
        </div>
        <Tabs
          defaultActiveKey="home"
          transition={true}
          id="noanim-tab-example"
          className="mb-3 fullscreen-modal-body-tabs"
          unmountOnExit={true}
        >
          <Tab
            eventKey="home"
            title={dataTranslate.home_tabs.additional.export_title}
          >
            <ExportsTab lang={lang} data={data.data} />
          </Tab>

          <Tab
            eventKey="profile"
            title={dataTranslate.home_tabs.additional.shipment_title}
          >
            <ShipmentTab lang={lang} data={data.data} />
          </Tab>

          <Tab
            eventKey="wallet"
            title={dataTranslate.home_tabs.additional.wallet_title}
          >
            <Suspense
              fallback={
                <div className="d-flex flex-column align-items-center justify-content-center w-100 h-100">
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">...</span>
                  </Spinner>
                </div>
              }
            >
              <WalletTab lang={lang} data={data.data} />
            </Suspense>
          </Tab>

          {/* <Tab
            eventKey="transfer"
            title={dataTranslate.home_tabs.additional.transfers_title}
          >
            <Suspense
              fallback={
                <div className="d-flex flex-column align-items-center justify-content-center w-100 h-100">
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">...</span>
                  </Spinner>
                </div>
              }
            >
              <TransferTab lang={lang} data={data.data} />
            </Suspense>
          </Tab> */}
        </Tabs>
      </Modal.Body>
    </Modal>
  );
};

export default FullModal;
